<template>
  <div>
    <div class="header-homepage">
      <v-row>
        <v-col cols="12" md="2">
          <!-- <div class="title-label-homepage">Section Names</div> -->
          <div class="title-label-homepage back-button" @click="$router.back()">
            <v-icon size="16">mdi-arrow-left</v-icon>
            <span>Back</span>
          </div>
        </v-col>
        <v-col cols="12" md="10">
          <div class="header-right-homepage">
            <div class="title-homepage">Home Page</div>
            <div class="homepage-actions">
              <span color="primary" class="primary--text" @click="handlePreviewHomepage">
                <v-icon class="primary--text" size="16">mdi-eye</v-icon> Preview
              </span>
            </div>
            <div>
              <v-btn small :disabled="loadingSave" color="primary" @click="handleSaveSections" :loading="loadingSave"
                >Save</v-btn
              >
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div class="homepage">
      <v-row>
        <v-col cols="12" md="2">
          <div v-if="loading">
            <v-sheet :color="`white`" class="pa-3">
              <v-skeleton-loader class="mx-auto" max-width="100%" type="list-item-two-line"></v-skeleton-loader>
              <v-skeleton-loader class="mx-auto" max-width="100%" type="list-item-two-line"></v-skeleton-loader>
              <v-skeleton-loader class="mx-auto" max-width="100%" type="list-item-two-line"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else class="panel-container">
            <div class="section-group">
              <div class="section-group-header" @click="toggleSidebarGroup('body')">
                <div class="section-group-title">
                  <v-icon size="18" class="expand-icon" :class="{ 'expand-icon-open': sidebarExpanded.body }"
                    >mdi-chevron-right</v-icon
                  >
                  <span>Body</span>
                </div>
                <span class="section-group-count">{{ sections.length }}</span>
              </div>
              <div v-show="sidebarExpanded.body" class="section-group-content">
                <div
                  v-if="sections.length > 0"
                  class="add-section-button"
                  @click.stop="() => handleAddSection('top', 'body')"
                >
                  + Add Section
                </div>
                <div class="list-panel-section">
                  <draggable
                    :list="sections"
                    :disabled="!draggingEnabled"
                    class="list-group"
                    ghost-class="ghost"
                    :move="checkMove"
                    @start="dragging = true"
                    @end="dragging = false"
                  >
                    <div
                      v-for="section in sections"
                      :key="section.id"
                      class="section-panel-item"
                      @click="scrollToSection(section.id)"
                    >
                      <div>
                        <v-icon color="primary" size="19">mdi-expand-all</v-icon>
                      </div>
                      {{ section.title }}
                    </div>
                  </draggable>
                </div>
                <div class="add-section-button" @click.stop="() => handleAddSection('bottom', 'body')">
                  + Add Section
                </div>
              </div>
            </div>
            <div class="section-group">
              <div class="section-group-header" @click="toggleSidebarGroup('footer')">
                <div class="section-group-title">
                  <v-icon size="18" class="expand-icon" :class="{ 'expand-icon-open': sidebarExpanded.footer }"
                    >mdi-chevron-right</v-icon
                  >
                  <span>Footer</span>
                </div>
                <span class="section-group-count">{{ sectionsFooter.length }}</span>
              </div>
              <div v-show="sidebarExpanded.footer" class="section-group-content">
                <div
                  v-if="sectionsFooter.length > 0"
                  class="add-section-button"
                  @click.stop="() => handleAddSection('top', 'footer')"
                >
                  + Add Section
                </div>
                <div class="list-panel-section">
                  <draggable
                    :list="sectionsFooter"
                    :disabled="!draggingEnabled"
                    class="list-group"
                    ghost-class="ghost"
                    :move="checkMove"
                    @start="dragging = true"
                    @end="dragging = false"
                  >
                    <div
                      v-for="section in sectionsFooter"
                      :key="section.id"
                      class="section-panel-item"
                      @click="scrollToSection(section.id)"
                    >
                      <div>
                        <v-icon color="primary" size="19">mdi-expand-all</v-icon>
                      </div>
                      {{ section.title }}
                    </div>
                  </draggable>
                </div>
                <div class="add-section-button" @click.stop="() => handleAddSection('bottom', 'footer')">
                  + Add Section
                </div>
              </div>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="10">
          <div v-if="loading">
            <v-sheet :color="`white`" class="pa-3">
              <v-skeleton-loader class="mx-auto" max-width="100%" type="card"></v-skeleton-loader>
            </v-sheet>
          </div>
          <div v-else>
            <div class="mb-5">
              <div class="header-group-sections">
                <span class="primary--text" style="font-weight: 600; color: #fff;">Body</span>
                <div class="header-group-sections-actions">
                  <v-btn color="text" small :disabled="!sections.length" @click="() => handleCopySections('body')">
                    <v-icon color="primary" left size="16">mdi-content-copy</v-icon>
                    Copy
                  </v-btn>
                  <v-btn color="text" small @click="() => handlePasteSections('body')">
                    <v-icon color="primary" left size="16">mdi-content-paste</v-icon>
                    Paste
                  </v-btn>
                </div>
              </div>
              <v-card class="pa-2">
                <div class="homepage-container">
                  <!-- add section -->
                  <div
                    class="plateholder-add-new"
                    @click="handleInsertNewSection(0, 'body')"
                    v-if="sections.length === 0"
                  >
                    <div class="plateholder-add-new-item">
                      <v-icon color="primary" size="20">mdi-plus</v-icon>
                      <span>Add Section</span>
                    </div>
                  </div>
                  <!-- list section -->
                  <div ref="listSection">
                    <div class="container-size">
                      <div class="section-item" v-for="(section, index) in sections" :key="section.id" :id="section.id">
                        <div class="section-item-actions">
                          <div class="action-item" @click="handleViewSection(section)">
                            <v-icon color="primary" size="19">mdi-expand-all</v-icon>
                            <span>Expand</span>
                          </div>
                          <div class="action-item" @click="handleViewSectionEditor(section)">
                            <v-icon color="primary" size="19">mdi-pencil</v-icon>
                            <span>Edit</span>
                          </div>
                          <div class="action-item" @click="handleDeleteSection(section)">
                            <v-icon color="error" size="20">mdi-delete</v-icon>
                            <span>Delete</span>
                          </div>
                        </div>
                        <div class="move-action">
                          <div
                            :class="index === 0 ? 'move-action-item-disabled' : 'move-action-item'"
                            @click="handleMoveSection(section, 'up')"
                          >
                            <v-icon color="primary" size="20">mdi-arrow-up</v-icon>
                          </div>
                          <div
                            :class="index === sections.length - 1 ? 'move-action-item-disabled' : 'move-action-item'"
                            @click="handleMoveSection(section, 'down')"
                          >
                            <v-icon color="primary" size="20">mdi-arrow-down</v-icon>
                          </div>
                        </div>
                        <div class="insert-new-section-action">
                          <div class="insert-new-section-action-item" @click="handleInsertNewSection(index, 'body')">
                            <v-icon color="primary" size="20">mdi-plus</v-icon>
                            <span>Add Section Above</span>
                          </div>
                          <div
                            class="insert-new-section-action-item"
                            @click="handleInsertNewSection(index + 1, 'body')"
                          >
                            <v-icon color="primary" size="20">mdi-plus</v-icon>
                            <span>Add Section Below</span>
                          </div>
                        </div>
                        <div v-html="section.html"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </div>
            <div>
              <div class="header-group-sections">
                <span class="primary--text" style="font-weight: 600; color: #fff;">Footer</span>
                <div class="header-group-sections-actions">
                  <v-btn
                    color="text"
                    small
                    :disabled="!sectionsFooter.length"
                    @click="() => handleCopySections('footer')"
                  >
                    <v-icon color="primary" left size="16">mdi-content-copy</v-icon>
                    Copy
                  </v-btn>
                  <v-btn color="text" small @click="() => handlePasteSections('footer')">
                    <v-icon color="primary" left size="16">mdi-content-paste</v-icon>
                    Paste
                  </v-btn>
                </div>
              </div>
              <v-card class="pa-2">
                <div class="homepage-container">
                  <!-- add section -->
                  <div
                    class="plateholder-add-new"
                    @click="handleInsertNewSection(0, 'footer')"
                    v-if="sectionsFooter.length === 0"
                  >
                    <div class="plateholder-add-new-item">
                      <v-icon color="primary" size="20">mdi-plus</v-icon>
                      <span>Add Section</span>
                    </div>
                  </div>
                  <!-- list section -->
                  <div ref="listSectionFooter">
                    <div class="container-size">
                      <div
                        class="section-item"
                        v-for="(section, index) in sectionsFooter"
                        :key="section.id"
                        :id="section.id"
                      >
                        <div class="section-item-actions">
                          <div class="action-item" @click="handleViewSection(section)">
                            <v-icon color="primary" size="19">mdi-expand-all</v-icon>
                            <span>Expand</span>
                          </div>
                          <div class="action-item" @click="handleViewSectionEditor(section, 'footer')">
                            <v-icon color="primary" size="19">mdi-pencil</v-icon>
                            <span>Edit</span>
                          </div>
                          <div class="action-item" @click="handleDeleteSection(section, 'footer')">
                            <v-icon color="error" size="20">mdi-delete</v-icon>
                            <span>Delete</span>
                          </div>
                        </div>
                        <div class="move-action">
                          <div
                            :class="index === 0 ? 'move-action-item-disabled' : 'move-action-item'"
                            @click="handleMoveSection(section, 'up', 'footer')"
                          >
                            <v-icon color="primary" size="20">mdi-arrow-up</v-icon>
                          </div>
                          <div
                            :class="
                              index === sectionsFooter.length - 1 ? 'move-action-item-disabled' : 'move-action-item'
                            "
                            @click="handleMoveSection(section, 'down', 'footer')"
                          >
                            <v-icon color="primary" size="20">mdi-arrow-down</v-icon>
                          </div>
                        </div>
                        <div class="insert-new-section-action">
                          <div class="insert-new-section-action-item" @click="handleInsertNewSection(index, 'footer')">
                            <v-icon color="primary" size="20">mdi-plus</v-icon>
                            <span>Add Section Above</span>
                          </div>
                          <div
                            class="insert-new-section-action-item"
                            @click="handleInsertNewSection(index + 1, 'footer')"
                          >
                            <v-icon color="primary" size="20">mdi-plus</v-icon>
                            <span>Add Section Below</span>
                          </div>
                        </div>
                        <div v-html="section.html"></div>
                      </div>
                    </div>
                  </div>
                </div>
              </v-card>
            </div>
            <div class="d-flex justify-end mt-3">
              <v-btn color="primary" @click="handleSaveSections" :loading="loadingSave">Save</v-btn>
            </div>
          </div>
        </v-col>
      </v-row>
      <div>
        <!-- Template Modal -->
        <v-dialog v-model="showSectionTemplateModal" fullscreen>
          <SelectSectionTemplate
            :typeInsert="typeInsert"
            @select="handleSectionTemplateSelect"
            @close="showSectionTemplateModal = false"
          />
        </v-dialog>
        <!-- View Section Modal -->
        <v-dialog v-model="viewExpandSection.showViewSection" fullscreen hide-overlay>
          <ViewSectionTemplate
            v-if="viewExpandSection.showViewSection"
            :open="viewExpandSection.showViewSection"
            :section="viewExpandSection.section"
            @close="viewExpandSection.showViewSection = false"
          />
        </v-dialog>
        <!-- View Homepage Modal -->
      </div>
      <!-- list section editor -->
      <div>
        <BannerSlideSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionBanner"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <BannerHsiaSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionBannerHsia"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardSonaSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardSona"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CustomizeCardSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCustomizeCard"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardCigarSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardCigar"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardKynorelleSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardKynorelle"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardHsiaGridSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardHsiaGrid"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardReviewHsiaGridSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardReviewHsiaGrid"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardHsiaCategorySectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardHsiaCategory"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardHsiaTagsSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardHsiaTags"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardFaqKynorelleSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardFaqKynorelle"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <SliderReviewKynorelleSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSliderReviewKynorelle"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardVideoSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardVideo"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardVideoSliderSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardVideoSlider"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <ProductsSliderSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionProducts"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <BannerKynorelleSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionBannerKynorelle"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <GridItemKynorelleSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGridItemKynorelle"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <GridItemKynorelle02SectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGridItemKynorelle02"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <MarkqueueKynorelleSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarkqueueKynorelle"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <MarqueeKyroroSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarqueeKyroro"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <MarqueeBoxerItemSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionMarqueeBoxerItem"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <GridItemKynorelle03SectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGridItemKynorelle03"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <GridItemKynorelle04SectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGridItemKynorelle04"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <GridItemKynorelle05SectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionGridItemKynorelle05"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <TextWithIconSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionTextWithIcon"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardHsiaTextWithIconSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardHsiaTextWithIcon"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <SliderItemFyroroSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSliderItemFyroro"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <SliderItemBoxerSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSliderItemBoxer"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <ProductWithVariantSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionProductWithVariant"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <FreestyleSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionFreestyle"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardGridBoxerSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardGridBoxer"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardWithTabsBoxerSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardWithTabsBoxer"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CardMultiBoxerSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardMultiBoxer"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <ReviewsBoxerSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCardReviewsBoxer"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <SliderBoxerProductSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionSliderBoxerProduct"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <ImageWithTextConvenFeet01SectionEditor
          v-if="
            viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionImageWithTextConvenFeet01
          "
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <ImageWithTextConvenFeet02SectionEditor
          v-if="
            viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionImageWithTextConvenFeet02
          "
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <ImageWithTextConvenFeet03SectionEditor
          v-if="
            viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionImageWithTextConvenFeet03
          "
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <IconGridWithHeroTextConvenFeetSectionEditor
          v-if="
            viewSectionEditor.show &&
              viewSectionEditor.section.type === sectionType.sectionIconGridWithHeroTextConvenFeet
          "
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitBannerSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitBanner"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitMarquee01SectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitMarquee01"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitMarqueeSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitMarquee"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitGirdImageSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitGirdImage"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitBestSallerSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitBestSaller"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitSideBySideSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitSideBySide"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitSlideSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitSlide"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitCollectionsSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitCollections"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitTextWithIconSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitTextWithIcon"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitReviewSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitReview"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CalyrafitFooterSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCalyrafitFooter"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CeflorecoProductWorldSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCeflorecoProductWorld"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CeflorecoFooterSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCeflorecoFooter"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CeflorecoLetsTalkSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCeflorecoLetsTalk"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CeflorecoBenefisSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCeflorecoBenefis"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CeflorecoMobileAppSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCeflorecoMobileApp"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CeflorecoSideBySideSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCeflorecoSideBySide"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CeflorecoTextGradientSectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCeflorecoTextGradient"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CeflorecoBanner2SectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCeflorecoBanner2"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
        <CeflorecoBanner1SectionEditor
          v-if="viewSectionEditor.show && viewSectionEditor.section.type === sectionType.sectionCeflorecoBanner1"
          :sectionEditor="viewSectionEditor"
          @close="handleCloseSectionEditor"
          @update:section="handleUpdateSection"
        />
      </div>
    </div>
    <v-dialog v-model="previewHomepage.open" fullscreen hide-overlay z-index="9999">
      <ViewHomepage
        v-if="previewHomepage.open"
        :open="previewHomepage.open"
        :sectionsHtml="previewHomepage.sectionsHtml"
        @close="handleClosePreviewHomepage"
      />
    </v-dialog>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import draggable from 'vuedraggable';
import dataTheme from './common/mixins/dataTheme';
import { sectionHomepage } from './common/section-templates/section-template-runtime';
import { sectionType } from './common/type';
import { handleHtmlData, optimizeRawHtmlData, regenerateSectionIds } from './common/utils';
import './styles/homepage.scss';
import './styles/swiper.scss';
// import './styles/sections.scss';

import { extractDataAttributesFromHTML } from './common/html/extract';
import SelectSectionTemplate from './modal/select-section-template.vue';
import ViewHomepage from './modal/view-homepage.vue';
import ViewSectionTemplate from './modal/view-section.vue';
import BannerHsiaSectionEditor from './section-editor/banner-hsia.vue';
import BannerKynorelleSectionEditor from './section-editor/banner-kynorelle.vue';
import BannerSlideSectionEditor from './section-editor/banner-slide.vue';
import CalyrafitBannerSectionEditor from './section-editor/calyrafit-banner.vue';
import CalyrafitBestSallerSectionEditor from './section-editor/calyrafit-best-saller.vue';
import CalyrafitCollectionsSectionEditor from './section-editor/calyrafit-collections.vue';
import CalyrafitFooterSectionEditor from './section-editor/calyrafit-footer.vue';
import CeflorecoBanner1SectionEditor from './section-editor/cefloreco-banner-1.vue';
import CeflorecoBanner2SectionEditor from './section-editor/cefloreco-banner-2.vue';
import CeflorecoTextGradientSectionEditor from './section-editor/cefloreco-text-gradient.vue';
import CeflorecoSideBySideSectionEditor from './section-editor/cefloreco-side-by-side.vue';
import CeflorecoMobileAppSectionEditor from './section-editor/cefloreco-mobile-app.vue';
import CeflorecoBenefisSectionEditor from './section-editor/cefloreco-benefis.vue';
import CeflorecoLetsTalkSectionEditor from './section-editor/cefloreco-lets-talk.vue';
import CeflorecoFooterSectionEditor from './section-editor/cefloreco-footer.vue';
import CeflorecoProductWorldSectionEditor from './section-editor/cefloreco-product-world.vue';
import CalyrafitGirdImageSectionEditor from './section-editor/calyrafit-gird-image.vue';
import CalyrafitMarquee01SectionEditor from './section-editor/calyrafit-marquee-01.vue';
import CalyrafitMarqueeSectionEditor from './section-editor/calyrafit-marquee.vue';
import CalyrafitReviewSectionEditor from './section-editor/calyrafit-review.vue';
import CalyrafitSideBySideSectionEditor from './section-editor/calyrafit-side-by-side.vue';
import CalyrafitSlideSectionEditor from './section-editor/calyrafit-slide.vue';
import CalyrafitTextWithIconSectionEditor from './section-editor/calyrafit-text-with-icon.vue';
import CardCigarSectionEditor from './section-editor/card-cigar.vue';
import CardFaqKynorelleSectionEditor from './section-editor/card-faq-kynorelle.vue';
import CardGridBoxerSectionEditor from './section-editor/card-grid-boxer.vue';
import CardHsiaCategorySectionEditor from './section-editor/card-hsia-category.vue';
import CardHsiaGridSectionEditor from './section-editor/card-hsia-grid.vue';
import CardHsiaTagsSectionEditor from './section-editor/card-hsia-tags.vue';
import CardHsiaTextWithIconSectionEditor from './section-editor/card-hsia-text-with-icon.vue';
import CardKynorelleSectionEditor from './section-editor/card-kynorelle.vue';
import CardMultiBoxerSectionEditor from './section-editor/card-multi-boxer.vue';
import CardReviewHsiaGridSectionEditor from './section-editor/card-review-hsia-grid.vue';
import CardSonaSectionEditor from './section-editor/card-sona.vue';
import CardVideoSliderSectionEditor from './section-editor/card-video-slider.vue';
import CardVideoSectionEditor from './section-editor/card-video.vue';
import CardWithTabsBoxerSectionEditor from './section-editor/card-with-tabs-boxer.vue';
import CustomizeCardSectionEditor from './section-editor/customize-card.vue';
import FreestyleSectionEditor from './section-editor/freestyle-section.vue';
import GridItemKynorelle02SectionEditor from './section-editor/grid-item-kynorelle-02.vue';
import GridItemKynorelle03SectionEditor from './section-editor/grid-item-kynorelle-03.vue';
import GridItemKynorelle04SectionEditor from './section-editor/grid-item-kynorelle-04.vue';
import GridItemKynorelle05SectionEditor from './section-editor/grid-item-kynorelle-05.vue';
import GridItemKynorelleSectionEditor from './section-editor/grid-item-kynorelle.vue';
import IconGridWithHeroTextConvenFeetSectionEditor from './section-editor/icon-grid-with-hero-text-conven-feet.vue';
import ImageWithTextConvenFeet01SectionEditor from './section-editor/image-with-text-conven-feet-01.vue';
import ImageWithTextConvenFeet02SectionEditor from './section-editor/image-with-text-conven-feet-02.vue';
import ImageWithTextConvenFeet03SectionEditor from './section-editor/image-with-text-conven-feet-03.vue';
import MarkqueueKynorelleSectionEditor from './section-editor/markqueue-kynorelle.vue';
import MarqueeBoxerItemSectionEditor from './section-editor/marquee-boxer-item.vue';
import MarqueeKyroroSectionEditor from './section-editor/marquee-kyroro.vue';
import ProductWithVariantSectionEditor from './section-editor/product-with-variant.vue';
import ProductsSliderSectionEditor from './section-editor/products-slider.vue';
import ReviewsBoxerSectionEditor from './section-editor/reviews-boxer.vue';
import SliderBoxerProductSectionEditor from './section-editor/slider-boxer-product.vue';
import SliderItemBoxerSectionEditor from './section-editor/slider-item-boxer.vue';
import SliderItemFyroroSectionEditor from './section-editor/slider-item-fyroro.vue';
import SliderReviewKynorelleSectionEditor from './section-editor/slider-review-kynorelle.vue';
import TextWithIconSectionEditor from './section-editor/text-with-icon.vue';

const TypePosition = {
  Body: 'body',
  Footer: 'footer',
};

export default {
  name: 'Homepage',
  components: {
    SelectSectionTemplate,
    ViewSectionTemplate,
    ViewHomepage,
    BannerSlideSectionEditor,
    BannerHsiaSectionEditor,
    CardSonaSectionEditor,
    CustomizeCardSectionEditor,
    CardCigarSectionEditor,
    CardKynorelleSectionEditor,
    CardHsiaGridSectionEditor,
    CardReviewHsiaGridSectionEditor,
    CardHsiaCategorySectionEditor,
    CardHsiaTagsSectionEditor,
    CardFaqKynorelleSectionEditor,
    SliderReviewKynorelleSectionEditor,
    CardVideoSectionEditor,
    CardVideoSliderSectionEditor,
    ProductsSliderSectionEditor,
    BannerKynorelleSectionEditor,
    GridItemKynorelleSectionEditor,
    GridItemKynorelle02SectionEditor,
    GridItemKynorelle03SectionEditor,
    GridItemKynorelle04SectionEditor,
    GridItemKynorelle05SectionEditor,
    MarkqueueKynorelleSectionEditor,
    MarqueeKyroroSectionEditor,
    MarqueeBoxerItemSectionEditor,
    TextWithIconSectionEditor,
    CardHsiaTextWithIconSectionEditor,
    SliderItemFyroroSectionEditor,
    SliderItemBoxerSectionEditor,
    ProductWithVariantSectionEditor,
    FreestyleSectionEditor,
    CardGridBoxerSectionEditor,
    CardWithTabsBoxerSectionEditor,
    CardMultiBoxerSectionEditor,
    ReviewsBoxerSectionEditor,
    SliderBoxerProductSectionEditor,
    ImageWithTextConvenFeet01SectionEditor,
    ImageWithTextConvenFeet02SectionEditor,
    ImageWithTextConvenFeet03SectionEditor,
    IconGridWithHeroTextConvenFeetSectionEditor,
    CalyrafitBannerSectionEditor,
    CalyrafitMarquee01SectionEditor,
    CalyrafitMarqueeSectionEditor,
    CalyrafitGirdImageSectionEditor,
    CalyrafitBestSallerSectionEditor,
    CalyrafitSideBySideSectionEditor,
    CalyrafitSlideSectionEditor,
    CalyrafitCollectionsSectionEditor,
    CalyrafitTextWithIconSectionEditor,
    CalyrafitReviewSectionEditor,
    CalyrafitFooterSectionEditor,
    CeflorecoBanner1SectionEditor,
    CeflorecoBanner2SectionEditor,
    CeflorecoTextGradientSectionEditor,
    CeflorecoSideBySideSectionEditor,
    CeflorecoMobileAppSectionEditor,
    CeflorecoBenefisSectionEditor,
    CeflorecoLetsTalkSectionEditor,
    CeflorecoFooterSectionEditor,
    CeflorecoProductWorldSectionEditor,
    draggable,
  },
  mixins: [dataTheme],
  data() {
    return {
      draggingEnabled: true,
      sidebarExpanded: {
        body: true,
        footer: true,
      },
      indexInsertNewSection: -1,
      typeInsert: '',
      typeEditor: '', //footer, body
      showSectionTemplateModal: false,
      previewHomepage: {
        open: false,
        sectionsHtml: '',
      },
      viewExpandSection: {
        showViewSection: false,
        section: {},
      },
      viewSectionEditor: {
        show: false,
        sectionExtract: {},
        section: {},
      },
      sectionType,
    };
  },

  methods: {
    handleAddSection(position, type = 'body') {
      this.typeInsert = type;
      const list = type === 'footer' ? this.sectionsFooter : this.sections;
      if (position === 'top') {
        this.indexInsertNewSection = 0;
        this.handleShowPopupSelectSectionTemplate();
      } else if (position === 'bottom') {
        this.indexInsertNewSection = list.length;
        this.handleShowPopupSelectSectionTemplate();
      }
    },
    toggleSidebarGroup(group) {
      this.sidebarExpanded = {
        ...this.sidebarExpanded,
        [group]: !this.sidebarExpanded[group],
      };
    },
    checkMove(event) {
      console.log(event.draggedContext.futureIndex, event.relatedContext.futureIndex);
      return true;
    },
    handlePreviewHomepage() {
      const regex = new RegExp(`prl-[a-z0-9]{6}`, 'g');
      const sections = [...cloneDeep(this.sections), ...cloneDeep(this.sectionsFooter)];
      let sectionsHtml = '';
      sections.forEach(section => {
        const uniqueId = Math.random()
          .toString(36)
          .slice(2, 8);
        sectionsHtml += section.html.replace(regex, uniqueId);
      });
      this.previewHomepage = {
        open: true,
        sectionsHtml: sectionsHtml,
      };
    },
    handleClosePreviewHomepage() {
      this.previewHomepage = {
        open: false,
        sectionsHtml: '',
      };
    },
    scrollToSection(sectionId) {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center',
        });
        element.classList.add('active-section');
        setTimeout(() => {
          element.classList.remove('active-section');
        }, 3000);
      }
    },
    handleViewSection(section) {
      const uniqueId = Math.random()
        .toString(36)
        .slice(2, 8);
      // anh e sau có maintain thì chú ý cái prefix là prl nhé, nó được set trong lúc chọn template
      const regex = new RegExp(`prl-[a-z0-9]{6}`, 'g');

      this.viewExpandSection.showViewSection = true;

      this.viewExpandSection.section = {
        ...section,
        html: section.html.replace(regex, uniqueId),
      };
    },
    handleSectionTemplateSelect(template, type) {
      if (type === TypePosition.Body) {
        if (this.indexInsertNewSection >= 0) {
          this.sections = [
            ...this.sections.slice(0, this.indexInsertNewSection),
            template,
            ...this.sections.slice(this.indexInsertNewSection),
          ];
        } else {
          this.sections = [...this.sections, template];
          this.indexInsertNewSection = this.sections.length - 1;
        }
      } else if (type === TypePosition.Footer) {
        if (this.indexInsertNewSection >= 0) {
          this.sectionsFooter = [
            ...this.sectionsFooter.slice(0, this.indexInsertNewSection),
            template,
            ...this.sectionsFooter.slice(this.indexInsertNewSection),
          ];
        } else {
          this.sectionsFooter = [...this.sectionsFooter, template];
          this.indexInsertNewSection = this.sectionsFooter.length - 1;
        }
      }

      this.showSectionTemplateModal = false;
      this.indexInsertNewSection = -1;
      setTimeout(() => {
        this.scrollToSection(template.id);
      }, 100);
    },
    handleShowPopupSelectSectionTemplate() {
      this.showSectionTemplateModal = true;
    },
    handleInsertNewSection(index, type = TypePosition.Body) {
      this.indexInsertNewSection = index;
      this.typeInsert = type;
      this.handleShowPopupSelectSectionTemplate();
    },
    handleDeleteSection(section, type = TypePosition.Body) {
      if (type === TypePosition.Body) {
        this.sections = this.sections.filter(item => item.id !== section.id);
      } else if (type === TypePosition.Footer) {
        this.sectionsFooter = this.sectionsFooter.filter(item => item.id !== section.id);
      }
    },
    handleSaveSections() {
      this.updateConfigTheme();
    },
    handleMoveSection(section, direction, type = TypePosition.Body) {
      if (type === TypePosition.Body) {
        const index = this.sections.findIndex(item => item.id === section.id);
        if (index === -1) return;
        const newSections = cloneDeep(this.sections);
        if (direction === 'up') {
          if (index === 0) return;
          newSections.splice(index, 1);
          newSections.splice(index - 1, 0, section);
        } else if (direction === 'down') {
          if (index === newSections.length - 1) return;
          newSections.splice(index, 1);
          newSections.splice(index + 1, 0, section);
        } else {
          return;
        }
        this.sections = newSections.map((item, index) => ({ ...item, position: index }));
      } else if (type === TypePosition.Footer) {
        const index = this.sectionsFooter.findIndex(item => item.id === section.id);
        if (index === -1) return;
        const newSectionsFooter = cloneDeep(this.sectionsFooter);
        if (direction === 'up') {
          if (index === 0) return;
          newSectionsFooter.splice(index, 1);
          newSectionsFooter.splice(index - 1, 0, section);
        } else if (direction === 'down') {
          if (index === newSectionsFooter.length - 1) return;
          newSectionsFooter.splice(index, 1);
          newSectionsFooter.splice(index + 1, 0, section);
        } else {
          return;
        }
        this.sectionsFooter = newSectionsFooter.map((item, index) => ({ ...item, position: index }));
      }

      setTimeout(() => {
        this.scrollToSection(section.id);
      }, 100);
    },
    handleViewSectionEditor(section, type = TypePosition.Body) {
      this.typeEditor = type;
      switch (section.type) {
        case sectionType.sectionFreestyle: {
          const sectionExtract = extractDataAttributesFromHTML.sectionFreestyle(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionBanner: {
          const sectionExtract = extractDataAttributesFromHTML.sectionBannerSlider(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionBannerHsia: {
          const sectionExtract = extractDataAttributesFromHTML.sectionBannerHsia(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionBannerKynorelle: {
          const sectionExtract = extractDataAttributesFromHTML.sectionBannerKynorelle(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGridItemKynorelle: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGridItemKynorelle(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGridItemKynorelle02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGridItemKynorelle02(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarkqueueKynorelle: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarkqueueKynorelle(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarqueeKyroro: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarqueeKyroro(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionMarqueeBoxerItem: {
          const sectionExtract = extractDataAttributesFromHTML.sectionMarqueeBoxerItem(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGridItemKynorelle03: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGridItemKynorelle03(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGridItemKynorelle04: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGridItemKynorelle04(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionGridItemKynorelle05: {
          const sectionExtract = extractDataAttributesFromHTML.sectionGridItemKynorelle05(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardSona: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardSona(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCustomizeCard: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCustomizeCard(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardCigar: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardCigar(section.html);

          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardKynorelle: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardKynorelle(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardHsiaGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardHsiaGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardReviewHsiaGrid: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardReviewHsiaGrid(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardHsiaCategory: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardHsiaCategory(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardHsiaTags: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardHsiaTags(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardFaqKynorelle: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardFaqKynorelle(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSliderReviewKynorelle: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSliderReviewKynorelle(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardVideo: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardVideo(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardVideoSlider: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardVideoSlider(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionProducts: {
          const sectionExtract = extractDataAttributesFromHTML.sectionProductsSlider(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionTextWithIcon: {
          const sectionExtract = extractDataAttributesFromHTML.sectionTextWithIcon(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardHsiaTextWithIcon: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardHsiaTextWithIcon(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSliderItemFyroro: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSliderItemFyroro(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSliderItemBoxer: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSliderItemBoxer(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionProductWithVariant: {
          const sectionExtract = extractDataAttributesFromHTML.sectionProductWithVariant(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardGridBoxer: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardGridBoxer(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardWithTabsBoxer: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardWithTabsBoxer(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardMultiBoxer: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardMultiBoxer(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCardReviewsBoxer: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCardReviewsBoxer(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionSliderBoxerProduct: {
          const sectionExtract = extractDataAttributesFromHTML.sectionSliderBoxerProduct(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionImageWithTextConvenFeet01: {
          const sectionExtract = extractDataAttributesFromHTML.sectionImageWithTextConvenFeet01(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionImageWithTextConvenFeet02: {
          const sectionExtract = extractDataAttributesFromHTML.sectionImageWithTextConvenFeet02(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionImageWithTextConvenFeet03: {
          const sectionExtract = extractDataAttributesFromHTML.sectionImageWithTextConvenFeet03(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionIconGridWithHeroTextConvenFeet: {
          const sectionExtract = extractDataAttributesFromHTML.sectionIconGridWithHeroTextConvenFeet(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitBanner: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitBanner(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitMarquee01: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitMarquee01(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitMarquee: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitMarquee(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitGirdImage: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitGirdImage(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitBestSaller: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitBestSaller(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitSideBySide: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitSideBySide(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitSlide: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitSlide(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitCollections: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitCollections(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitTextWithIcon: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitTextWithIcon(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitReview: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitReview(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCalyrafitFooter: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCalyrafitFooter(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCeflorecoBanner1: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCeflorecoBanner1(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCeflorecoProductWorld: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCeflorecoProductWorld(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCeflorecoBanner2: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCeflorecoBanner2(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCeflorecoTextGradient: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCeflorecoTextGradient(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCeflorecoSideBySide: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCeflorecoSideBySide(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCeflorecoMobileApp: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCeflorecoMobileApp(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCeflorecoBenefis: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCeflorecoBenefis(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCeflorecoLetsTalk: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCeflorecoLetsTalk(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        case sectionType.sectionCeflorecoFooter: {
          const sectionExtract = extractDataAttributesFromHTML.sectionCeflorecoFooter(section.html);
          this.viewSectionEditor = {
            show: true,
            sectionExtract,
            section: section,
          };
          break;
        }
        default:
          break;
      }
    },
    handleCloseSectionEditor() {
      this.viewSectionEditor = {
        show: false,
        sectionExtract: {},
        section: {},
      };
    },
    handleUpdateSection(section) {
      if (this.typeEditor === TypePosition.Body) {
        this.sections = this.sections.map(item => (item.id === section.id ? section : item));
      } else if (this.typeEditor === TypePosition.Footer) {
        this.sectionsFooter = this.sectionsFooter.map(item => (item.id === section.id ? section : item));
      }
    },
    async handleCopySections(type = TypePosition.Body) {
      const sections = type === TypePosition.Body ? this.sections : this.sectionsFooter;
      const html = (sections || []).map(section => section.html).join('');
      if (!html) {
        this.$store.commit('setMessages', { messages: 'No sections to copy', type: 'warning' });
        return;
      }

      try {
        await navigator.clipboard.writeText(html);
        this.$store.commit('setMessages', { messages: 'Sections copied to clipboard', type: 'success' });
      } catch (err) {
        console.error('Failed to copy sections: ', err);
        this.$store.commit('setMessages', { messages: 'Failed to copy sections', type: 'error' });
      }
    },
    async handlePasteSections(type = TypePosition.Body) {
      let clipboardText = '';
      try {
        clipboardText = await navigator.clipboard.readText();
      } catch (err) {
        console.error('Failed to read clipboard: ', err);
        this.$store.commit('setMessages', {
          messages: 'Unable to read clipboard. Please allow clipboard permission and try again.',
          type: 'error',
        });
        return;
      }

      if (!clipboardText?.trim()) {
        this.$store.commit('setMessages', { messages: 'Clipboard is empty', type: 'warning' });
        return;
      }

      const parsedSections = regenerateSectionIds(handleHtmlData(clipboardText));
      if (!parsedSections.length) {
        this.$store.commit('setMessages', { messages: 'No valid sections found in clipboard', type: 'warning' });
        return;
      }

      if (type === TypePosition.Body) {
        this.sections = [...this.sections, ...parsedSections];
      } else if (type === TypePosition.Footer) {
        this.sectionsFooter = [...this.sectionsFooter, ...parsedSections];
      }
      this.$store.commit('setMessages', { messages: 'Sections pasted', type: 'success' });
    },
  },
  watch: {
    sections: {
      handler(newVal, oldVal) {
        if (oldVal && newVal.length !== oldVal.length) {
          this.sections = optimizeRawHtmlData.watchSectionStyles(newVal, oldVal);
        }

        this.sectionsHtml = newVal.map(section => section.html).join('');
        this.$nextTick(() => {
          sectionHomepage();
        });
      },
    },
    sectionsFooter: {
      handler(newVal, oldVal) {
        if (oldVal && newVal.length !== oldVal.length) {
          this.sectionsFooter = optimizeRawHtmlData.watchSectionStyles(newVal, oldVal);
        }

        this.footerHtml = newVal.map(section => section.html).join('');
        this.$nextTick(() => {
          sectionHomepage();
        });
      },
    },
  },
};
</script>
